import { visitServiceApi } from "../../app/visitServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType } from "../../types";
import {
  GetVisitRangeParamsType,
  MyVisitListExportParams,
  MyVisitQueryParams,
  MyVisitResponseType,
  TeamVisitQueryParams,
  TeamVisitResponseType,
  VisitDetailsResponseType,
  VisitListExportQueryParams,
  VisitListExportType,
} from "../../types/visit";

export const visitApi = visitServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyVisitList: builder.query<
      MyVisitResponseType,
      GetQueryArgsType<MyVisitQueryParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getMyVisitList,
        ...queryArgs,
      }),
    }),
    getMyVisitListMinimum: builder.query<
      MyVisitResponseType,
      GetQueryArgsType<MyVisitQueryParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getMyVisitListMinimum,
        ...queryArgs,
      }),
    }),
    getTeamVisitList: builder.query<
      TeamVisitResponseType,
      GetQueryArgsType<TeamVisitQueryParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getTeamVisitList,
        ...queryArgs,
      }),
    }),
    getVisitDetails: builder.query<VisitDetailsResponseType, string>({
      query: (id) => ({
        url: `${API_URL.getVisitDetails}/${id}`,
      }),
    }),
    getVisitListExport: builder.query<
      VisitListExportType,
      GetQueryArgsType<VisitListExportQueryParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getVisitListExport,
        ...queryArgs,
      }),
    }),
    getMyVisitListExport: builder.query<
      VisitListExportType,
      GetQueryArgsType<MyVisitListExportParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getVisitListExport,
        params: {
          ...queryArgs,
        },
      }),
    }),
    getVisitDetailsExport: builder.query<
      void,
      GetQueryArgsType<GetVisitRangeParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getVisitDetailsExport,
        responseHandler: async (response: any) => {
          const blob = await response.blob();
          return window.URL.createObjectURL(blob);
        },
        cache: "no-cache",
        ...queryArgs,
      }),
    }),
  }),
});

export const {
  useGetMyVisitListQuery,
  useGetMyVisitListMinimumQuery,
  useGetTeamVisitListQuery,
  useGetVisitDetailsQuery,
  useGetVisitListExportQuery,
  useGetMyVisitListExportQuery,
  useGetVisitDetailsExportQuery,
  useLazyGetVisitDetailsExportQuery,
} = visitApi;
